(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-fetch-date.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-fetch-date.js');
"use strict";

const {
  useParams
} = ReactRouterDOM;
const {
  tipsenApi
} = svs.components.tipsen.store;
const {
  useSelector
} = ReactRedux;
const {
  selectDrawProductIds
} = svs.components.tipsen.engine.selectors.engineSelectors;
const useFetchDate = () => {
  var _svs$tipsen, _svs$tipsen2, _data$results;
  const productId = useSelector(selectDrawProductIds)[0];
  const hasServerLoadedDate = Boolean((_svs$tipsen = svs.tipsen) === null || _svs$tipsen === void 0 || (_svs$tipsen = _svs$tipsen.data) === null || _svs$tipsen === void 0 ? void 0 : _svs$tipsen.latestResultDate);
  let noParamFetchDate = hasServerLoadedDate ? new Date((_svs$tipsen2 = svs.tipsen) === null || _svs$tipsen2 === void 0 || (_svs$tipsen2 = _svs$tipsen2.data) === null || _svs$tipsen2 === void 0 ? void 0 : _svs$tipsen2.latestResultDate) : new Date();

  const {
    data,
    error
  } = tipsenApi.useGetDrawsResultsQuery({
    productId
  }, {
    skip: hasServerLoadedDate || !productId
  });

  let noDrawsDateAvailable = false;
  if (!hasServerLoadedDate && (error === null || error === void 0 ? void 0 : error.status) === 404) {
    noDrawsDateAvailable = true;
  } else if (data !== null && data !== void 0 && (_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length && !error) {
    const [firsResult] = data.results;
    noParamFetchDate = new Date(firsResult.regCloseTime);
  }
  const {
    date: dateParam
  } = useParams();
  const hasDateParam = Boolean(dateParam);
  let fetchDate;
  let currentDate;
  if (dateParam) {
    const [year, month, day] = dateParam.split('-');
    fetchDate = {
      day: parseInt(day, 10),
      month: parseInt(month, 10),
      year: parseInt(year, 10)
    };
    currentDate = new Date(dateParam);
  } else {
    fetchDate = {
      day: noParamFetchDate.getDate(),
      month: noParamFetchDate.getMonth() + 1,
      year: noParamFetchDate.getFullYear()
    };
    currentDate = noParamFetchDate;
  }
  return [fetchDate, currentDate, hasDateParam, noDrawsDateAvailable];
};
setGlobal('svs.components.tipsen.routeResult.useFetchDate', useFetchDate);

 })(window);